import orderBy from 'lodash/orderBy';

const sortAscToDesc = (x, y) => {
  const a = x.firstName.toUpperCase();
  const b = y.firstName.toUpperCase();

  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};

const sortDescToAsc = (x, y) => {
  const a = x.firstName.toUpperCase();
  const b = y.firstName.toUpperCase();

  if (a < b) return 1;
  if (a > b) return -1;
  return 0;
};

const sortActivityDescToAsc = (x, y) => {
  const a = parseInt(x.assignmentCount, 10);
  const b = parseInt(y.assignmentCount, 10);

  if (a < b) return 1;
  if (a > b) return -1;
  return 0;
};

const sortActivityAscToDesc = (x, y) => {
  const a = parseInt(x.assignmentCount, 10);
  const b = parseInt(y.assignmentCount, 10);

  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};

const customSort = (list = [], primaryField, sortDirection) => {
  const orderedList = orderBy(
    list,
    (item) =>
      isNaN(item[primaryField])
        ? item[primaryField].toLowerCase()
        : item[primaryField],
    [sortDirection]
  );
  return orderedList;
};

export {
  sortAscToDesc,
  sortDescToAsc,
  sortActivityAscToDesc,
  sortActivityDescToAsc,
  customSort
};



// WEBPACK FOOTER //
// ./components/student-list/student-list-util.js